<i18n src="./resources/locales.json"></i18n>

<template>
  <Component
    :is="selectedSupervisorDashboardComponent"
    v-if="isSupervisor && $featuresManager.supervisorFeatures.enable"
  />
  <EcsAgentInformationCenter v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAgentInformationCenter from '@/components/ecs-agent-information-center/EcsAgentInformationCenter';
import EcsSupervisorInformationCenter from '@/components/ecs-supervisor-information-center/EcsSupervisorInformationCenter';
import EcsBusinessProcessSummaryTable from '@/components/ecs-business-process-summary-table/EcsBusinessProcessSummaryTable';

export default {
  name: 'EcsDashboardPage',

  components: { EcsAgentInformationCenter, EcsSupervisorInformationCenter, EcsBusinessProcessSummaryTable },

  computed: {
    ...mapGetters('AGENT', ['isSupervisor']),
    ...mapGetters('DASHBOARD', ['selectedSupervisorDashboardComponent'])
  }
};
</script>

<style scoped></style>
